var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_3566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6898 1.80725C5.79625 2.06205 5.676 2.3549 5.4212 2.46136C3.10622 3.42857 1.5 5.65091 1.5 8.22408C1.5 11.675 4.39469 14.5 8 14.5C11.6053 14.5 14.5 11.675 14.5 8.22408C14.5 5.65091 12.8938 3.42857 10.5788 2.46136C10.324 2.3549 10.2037 2.06205 10.3102 1.80725C10.4167 1.55246 10.7095 1.4322 10.9643 1.53866C13.6242 2.64998 15.5 5.21883 15.5 8.22408C15.5 12.2577 12.1267 15.5 8 15.5C3.87332 15.5 0.5 12.2577 0.5 8.22408C0.5 5.21883 2.37578 2.64998 5.03569 1.53866C5.29049 1.4322 5.58334 1.55246 5.6898 1.80725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0.125C8.27614 0.125 8.5 0.348858 8.5 0.625L8.5 6.53125C8.5 6.80739 8.27614 7.03125 8 7.03125C7.72386 7.03125 7.5 6.80739 7.5 6.53125L7.5 0.625C7.5 0.348858 7.72386 0.125 8 0.125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_3566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.cef9cc7b2f63d379a16634dc69dd5981.svg";
export { ForwardRef as ReactComponent };